import type { TextareaHTMLAttributes } from 'react';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  hint?: string;
}

export function Textarea({ label, hint, required, rows = 4, className = '', ...rest }: TextareaProps) {
  const control = (
    <div className="tr-field__control tr-textarea-wrap">
      <textarea className="tr-textarea" rows={rows} required={required} {...rest} />
    </div>
  );
  if (!label) return control;
  return (
    <label className={`tr-field ${className}`.trim()}>
      <span className="tr-field__label">
        {label}
        {required && <span className="tr-field__req">*</span>}
      </span>
      {control}
      {hint && <span className="tr-field__hint">{hint}</span>}
    </label>
  );
}
